// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Shared responsive — tablet ≤1189px, mobile ≤767.98px
 * Modules: ClientOffer, businessSector, clients, employees, transportDocuments
 */

/* ===== TABLET (≤1189px) ===== */
@media (max-width: 1189px) {
  .qrf-page--list .bs-list-filter__toolbar,
  .qrf-page--list .qrf-list-toolbar,
  .qrf-page--list .qrf-list-toolbar--simple,
  .qrf-page--list.bs-brand-page > .my-3 {
    flex-direction: column;
    align-items: stretch;
    gap: 0.65rem;
  }

  .qrf-page--list .bs-list-filter__toolbar-actions,
  .qrf-page--list .qrf-list-toolbar > .qrf-btn-submit,
  .qrf-page--list .qrf-list-toolbar > a,
  .qrf-page--list .qrf-list-toolbar > .btn {
    margin-inline-start: 0 !important;
    width: 100%;
    justify-content: center;
  }

  .qrf-page--list .bs-list-filter__toggle,
  .qrf-page--list .qrf-list-filter-toggle {
    flex-basis: auto;
    width: 100%;
  }

  .qrf-page--list .bs-list-filter__toggle-label,
  .qrf-page--list .bs-list-filter__toggle > span:first-child,
  .qrf-page--list .qrf-list-filter-toggle .qrf-accordion__head-text {
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
  }

  .qrf-page--list .bs-list-filter__toggle-icons,
  .qrf-page--list .qrf-list-filter-toggle .qrf-accordion__chevron {
    flex-shrink: 0;
    width: auto !important;
    margin-inline-start: 0 !important;
  }

  .qrf-page--list .bs-list-filter__body,
  .qrf-page--list .qrf-list-panel__body {
    padding: 0.85rem;
  }

  .qrf-page--list .bs-list-filter__actions,
  .qrf-page--list .qrf-list-filter-actions,
  .qrf-page--list .td-list-filter-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .qrf-page--list .bs-brand-filter-btn--apply,
  .qrf-page--list .bs-brand-filter-btn--reset,
  .qrf-page--list .clients-filter-btn--apply,
  .qrf-page--list .clients-filter-btn--reset,
  .qrf-page--list .qrf-btn-submit--approve,
  .qrf-page--list .qrf-btn-filter-reset,
  .qrf-page--list .btn.show_result,
  .qrf-page--list .btn.show_all,
  .qrf-page--list .btn-yellow,
  .qrf-page--list .btn-orange,
  .qrf-page--list .btn-blue {
    width: 100% !important;
    justify-content: center !important;
  }

  .qrf-page--list .table_wrapper .table-responsive,
  .qrf-page--list .qrf-items-table-wrap,
  .qrf-page--list .show-bs-partners-wrap,
  .td-list-page .table_wrapper .table-responsive,
  .td-list-page .qrf-items-table-wrap {
    -webkit-overflow-scrolling: touch;
  }

  .clients-page .qrf-list-row-actions,
  .qrf-page--list .qrf-list-row-actions,
  .td-list-actions__inner,
  .qrf-page--list .table_wrapper td.d-flex {
    flex-wrap: wrap;
    gap: 0.35rem;
    justify-content: center;
  }

  /* Transport list — filter columns full width */
  .td-list-page .row.p-col-10 > [class*="col-"]:not(.ms-auto) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .td-list-page .row.p-col-10 > .ms-auto {
    flex: 0 0 100%;
    max-width: 100%;
    margin-inline-start: 0 !important;
  }

  /* Show pages */
  .show-business-sector-page .show-bs-stats-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .show-business-sector-page .show-bs-actions-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .show-business-sector-page .show-bs-hero-badges {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* Form pages */
  .qrf-page--form .nav-tabs,
  .bs-brand-page .nav-tabs,
  .add-tripway-partner-form .nav-tabs {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    border-bottom: 1px solid var(--qrf-border, #dee2e6);
  }

  .qrf-page--form .nav-tabs .nav-link,
  .bs-brand-page .nav-tabs .nav-link {
    white-space: nowrap;
    flex-shrink: 0;
  }

  .qrf-page--form .qrf-form-footer,
  .qrf-page--form .qrf-form-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .qrf-page--form .qrf-form-footer .qrf-btn-submit,
  .qrf-page--form .qrf-form-footer .btn,
  .qrf-page--form .qrf-form-actions .btn,
  .qrf-page--form .qrf-form-actions .show_result,
  .qrf-page--form .qrf-form-actions .show_all {
    width: 100%;
  }

  /* Wizard steps — horizontal scroll on tablet */
  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Transport document view */
  .tdv-header-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .tdv-header-actions {
    width: 100%;
    justify-content: center;
  }

  .tdv-field-row__value {
    max-width: 55%;
  }

  .tdv-map-wrap iframe {
    height: 360px;
  }

  /* Modals */
  .qrf-modal__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .qrf-modal__footer .qrf-btn-submit,
  .qrf-modal__footer .qrf-btn-filter-reset,
  .qrf-modal__footer .btn {
    width: 100%;
    justify-content: center;
  }

  .co-status-modal__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  /* Partners table in forms */
  .qrf-form .table-responsive,
  .div-bg .table-responsive {
    -webkit-overflow-scrolling: touch;
  }

  /* Client offer view page */
  .qrf-view-hero--actions {
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .qrf-view-hero__actions {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  /* Employees list — wide table horizontal scroll */
  .bs-brand-page.qrf-page--list .qrf-list-table {
    min-width: 1100px;
  }
}

/* ===== MOBILE (≤767.98px) ===== */
@media (max-width: 767.98px) {
  .qrf-page--list,
  .qrf-page--form,
  .td-list-page,
  .tdv-page {
    padding-inline: 0.35rem;
  }

  .qrf-page--list .bs-list-filter__toolbar,
  .qrf-page--list .qrf-list-toolbar,
  .qrf-page--list .qrf-list-toolbar--simple {
    padding: 0.55rem 0.65rem;
  }

  .qrf-page--list .bs-list-filter__body,
  .qrf-page--list .qrf-list-panel__body {
    padding: 0.65rem;
  }

  .qrf-page--list .table_wrapper .table thead th,
  .qrf-page--list .qrf-list-table thead th,
  .td-list-page .qrf-list-table thead th {
    font-size: 0.75rem;
    padding: 0.4rem 0.35rem !important;
  }

  .qrf-page--list .table_wrapper .table tbody td,
  .qrf-page--list .qrf-list-table tbody td,
  .td-list-page .qrf-list-table tbody td {
    font-size: 0.8125rem;
    padding: 0.35rem 0.35rem !important;
  }

  .clients-page .qrf-list-row-actions {
    flex-wrap: wrap;
    justify-content: flex-start;
    white-space: normal;
  }

  .show-business-sector-page .show-bs-stats-grid,
  .show-business-sector-page .show-bs-actions-grid {
    grid-template-columns: 1fr;
  }

  .show-bs-field,
  .tdv-field-row {
    flex-direction: column;
    align-items: stretch;
    gap: 0.35rem;
  }

  .show-bs-value,
  .tdv-field-row__value {
    max-width: 100%;
    text-align: start;
  }

  .td-list-actions__inner {
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .td-list-actions__btn {
    width: 2rem;
    height: 2rem;
  }

  .qrf-page--form .qrf-form-legacy-shell {
    padding: 0.85rem 1rem;
  }

  .qrf-page--form .card-body {
    padding: 0.85rem;
  }

  .tdv-card {
    padding: 0.85rem 0.85rem 1.25rem;
  }

  .tdv-map-wrap iframe {
    height: 260px;
  }

  .tdv-invoice-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .co-status-modal__grid {
    grid-template-columns: 1fr;
  }

  /* Show employee / legacy show pages */
  .div-bg > .d-flex.flex-wrap.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 0.5rem;
  }

  .div-bg > .d-flex.flex-wrap.justify-content-between > .btn,
  .div-bg > .d-flex.flex-wrap.justify-content-between > a {
    width: 100%;
    justify-content: center;
  }

  /* Wizard steps — mobile sizing */
  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface {
    padding: 0.85rem 0.65rem 1rem;
  }

  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__badge {
    width: 2.65rem;
    height: 2.65rem;
    font-size: 1.05rem;
  }

  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__title {
    font-size: 0.78rem;
    max-width: 5.5rem;
  }

  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__connector-track {
    height: 8px;
  }

  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface.is-lang-ar .twp-add-partner-steps__title {
    font-size: 0.8rem;
    max-width: 6.25rem;
    line-height: 1.5;
  }

  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface.is-lang-ar .twp-add-partner-steps__node {
    min-width: 5.5rem;
    max-width: 6.75rem;
  }

  .qrf-page--list .bs-brand-pagination-nav,
  .qrf-page--list .qrf-list-pagination {
    margin-top: 0.85rem;
  }

  .qrf-page--list .bs-brand-pagination .page-link,
  .qrf-page--list .qrf-pagination .page-link {
    padding: 0.35rem 0.55rem;
    font-size: 0.8125rem;
  }

  /* Client offer view — stack actions on mobile */
  .qrf-view-hero--actions {
    flex-direction: column;
    align-items: stretch;
  }

  .qrf-view-hero__actions {
    margin-inline-start: 0;
    width: 100%;
    flex-direction: column;
  }

  .qrf-view-copy-btn {
    width: 100%;
    justify-content: flex-start;
  }

  .qrf-view-copy-btn__arrow {
    margin-inline-start: auto;
  }

  .qrf-customer-reg {
    flex-wrap: wrap;
  }

  .qrf-customer-reg__content {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(100% - 3.5rem);
  }

  .qrf-switch--readonly {
    margin-inline-start: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/moduleResponsive.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,iCAAiC;AACjC;EACE;;;;IAIE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;;;;IAIE,iCAAiC;IACjC,WAAW;IACX,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;IAChB,WAAW;EACb;;EAEA;;;IAGE,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,cAAc;IACd,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;;;;;;;;;IAWE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;;;;;IAKE,iCAAiC;EACnC;;EAEA;;;;IAIE,eAAe;IACf,YAAY;IACZ,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iCAAiC;EACnC;;EAEA,eAAe;EACf;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA,eAAe;EACf;;;IAGE,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,mDAAmD;EACrD;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;;;IAKE,WAAW;EACb;;EAEA,+CAA+C;EAC/C;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,4BAA4B;EAC5B;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA,WAAW;EACX;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;EAClD;;EAEA,4BAA4B;EAC5B;;IAEE,iCAAiC;EACnC;;EAEA,2BAA2B;EAC3B;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA,kDAAkD;EAClD;IACE,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE;;;;IAIE,uBAAuB;EACzB;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;;;IAGE,oBAAoB;IACpB,mCAAmC;EACrC;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA,iCAAiC;EACjC;IACE,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA,gDAAgD;EAChD;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAA6B;IAA7B,cAA6B;IAA7B,+BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/**\n * Shared responsive — tablet ≤1189px, mobile ≤767.98px\n * Modules: ClientOffer, businessSector, clients, employees, transportDocuments\n */\n\n/* ===== TABLET (≤1189px) ===== */\n@media (max-width: 1189px) {\n  .qrf-page--list .bs-list-filter__toolbar,\n  .qrf-page--list .qrf-list-toolbar,\n  .qrf-page--list .qrf-list-toolbar--simple,\n  .qrf-page--list.bs-brand-page > .my-3 {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.65rem;\n  }\n\n  .qrf-page--list .bs-list-filter__toolbar-actions,\n  .qrf-page--list .qrf-list-toolbar > .qrf-btn-submit,\n  .qrf-page--list .qrf-list-toolbar > a,\n  .qrf-page--list .qrf-list-toolbar > .btn {\n    margin-inline-start: 0 !important;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .qrf-page--list .bs-list-filter__toggle,\n  .qrf-page--list .qrf-list-filter-toggle {\n    flex-basis: auto;\n    width: 100%;\n  }\n\n  .qrf-page--list .bs-list-filter__toggle-label,\n  .qrf-page--list .bs-list-filter__toggle > span:first-child,\n  .qrf-page--list .qrf-list-filter-toggle .qrf-accordion__head-text {\n    flex: 1 1 auto;\n    min-width: 0;\n    width: auto;\n  }\n\n  .qrf-page--list .bs-list-filter__toggle-icons,\n  .qrf-page--list .qrf-list-filter-toggle .qrf-accordion__chevron {\n    flex-shrink: 0;\n    width: auto !important;\n    margin-inline-start: 0 !important;\n  }\n\n  .qrf-page--list .bs-list-filter__body,\n  .qrf-page--list .qrf-list-panel__body {\n    padding: 0.85rem;\n  }\n\n  .qrf-page--list .bs-list-filter__actions,\n  .qrf-page--list .qrf-list-filter-actions,\n  .qrf-page--list .td-list-filter-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .qrf-page--list .bs-brand-filter-btn--apply,\n  .qrf-page--list .bs-brand-filter-btn--reset,\n  .qrf-page--list .clients-filter-btn--apply,\n  .qrf-page--list .clients-filter-btn--reset,\n  .qrf-page--list .qrf-btn-submit--approve,\n  .qrf-page--list .qrf-btn-filter-reset,\n  .qrf-page--list .btn.show_result,\n  .qrf-page--list .btn.show_all,\n  .qrf-page--list .btn-yellow,\n  .qrf-page--list .btn-orange,\n  .qrf-page--list .btn-blue {\n    width: 100% !important;\n    justify-content: center !important;\n  }\n\n  .qrf-page--list .table_wrapper .table-responsive,\n  .qrf-page--list .qrf-items-table-wrap,\n  .qrf-page--list .show-bs-partners-wrap,\n  .td-list-page .table_wrapper .table-responsive,\n  .td-list-page .qrf-items-table-wrap {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .clients-page .qrf-list-row-actions,\n  .qrf-page--list .qrf-list-row-actions,\n  .td-list-actions__inner,\n  .qrf-page--list .table_wrapper td.d-flex {\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    justify-content: center;\n  }\n\n  /* Transport list — filter columns full width */\n  .td-list-page .row.p-col-10 > [class*=\"col-\"]:not(.ms-auto) {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .td-list-page .row.p-col-10 > .ms-auto {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin-inline-start: 0 !important;\n  }\n\n  /* Show pages */\n  .show-business-sector-page .show-bs-stats-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .show-business-sector-page .show-bs-actions-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .show-business-sector-page .show-bs-hero-badges {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  /* Form pages */\n  .qrf-page--form .nav-tabs,\n  .bs-brand-page .nav-tabs,\n  .add-tripway-partner-form .nav-tabs {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    border-bottom: 1px solid var(--qrf-border, #dee2e6);\n  }\n\n  .qrf-page--form .nav-tabs .nav-link,\n  .bs-brand-page .nav-tabs .nav-link {\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .qrf-page--form .qrf-form-footer,\n  .qrf-page--form .qrf-form-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .qrf-page--form .qrf-form-footer .qrf-btn-submit,\n  .qrf-page--form .qrf-form-footer .btn,\n  .qrf-page--form .qrf-form-actions .btn,\n  .qrf-page--form .qrf-form-actions .show_result,\n  .qrf-page--form .qrf-form-actions .show_all {\n    width: 100%;\n  }\n\n  /* Wizard steps — horizontal scroll on tablet */\n  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Transport document view */\n  .tdv-header-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .tdv-header-actions {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .tdv-field-row__value {\n    max-width: 55%;\n  }\n\n  .tdv-map-wrap iframe {\n    height: 360px;\n  }\n\n  /* Modals */\n  .qrf-modal__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .qrf-modal__footer .qrf-btn-submit,\n  .qrf-modal__footer .qrf-btn-filter-reset,\n  .qrf-modal__footer .btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .co-status-modal__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  /* Partners table in forms */\n  .qrf-form .table-responsive,\n  .div-bg .table-responsive {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Client offer view page */\n  .qrf-view-hero--actions {\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  .qrf-view-hero__actions {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  /* Employees list — wide table horizontal scroll */\n  .bs-brand-page.qrf-page--list .qrf-list-table {\n    min-width: 1100px;\n  }\n}\n\n/* ===== MOBILE (≤767.98px) ===== */\n@media (max-width: 767.98px) {\n  .qrf-page--list,\n  .qrf-page--form,\n  .td-list-page,\n  .tdv-page {\n    padding-inline: 0.35rem;\n  }\n\n  .qrf-page--list .bs-list-filter__toolbar,\n  .qrf-page--list .qrf-list-toolbar,\n  .qrf-page--list .qrf-list-toolbar--simple {\n    padding: 0.55rem 0.65rem;\n  }\n\n  .qrf-page--list .bs-list-filter__body,\n  .qrf-page--list .qrf-list-panel__body {\n    padding: 0.65rem;\n  }\n\n  .qrf-page--list .table_wrapper .table thead th,\n  .qrf-page--list .qrf-list-table thead th,\n  .td-list-page .qrf-list-table thead th {\n    font-size: 0.75rem;\n    padding: 0.4rem 0.35rem !important;\n  }\n\n  .qrf-page--list .table_wrapper .table tbody td,\n  .qrf-page--list .qrf-list-table tbody td,\n  .td-list-page .qrf-list-table tbody td {\n    font-size: 0.8125rem;\n    padding: 0.35rem 0.35rem !important;\n  }\n\n  .clients-page .qrf-list-row-actions {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    white-space: normal;\n  }\n\n  .show-business-sector-page .show-bs-stats-grid,\n  .show-business-sector-page .show-bs-actions-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .show-bs-field,\n  .tdv-field-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.35rem;\n  }\n\n  .show-bs-value,\n  .tdv-field-row__value {\n    max-width: 100%;\n    text-align: start;\n  }\n\n  .td-list-actions__inner {\n    flex-wrap: wrap;\n    gap: 0.25rem;\n  }\n\n  .td-list-actions__btn {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .qrf-page--form .qrf-form-legacy-shell {\n    padding: 0.85rem 1rem;\n  }\n\n  .qrf-page--form .card-body {\n    padding: 0.85rem;\n  }\n\n  .tdv-card {\n    padding: 0.85rem 0.85rem 1.25rem;\n  }\n\n  .tdv-map-wrap iframe {\n    height: 260px;\n  }\n\n  .tdv-invoice-table {\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .co-status-modal__grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Show employee / legacy show pages */\n  .div-bg > .d-flex.flex-wrap.justify-content-between {\n    flex-direction: column;\n    align-items: stretch !important;\n    gap: 0.5rem;\n  }\n\n  .div-bg > .d-flex.flex-wrap.justify-content-between > .btn,\n  .div-bg > .d-flex.flex-wrap.justify-content-between > a {\n    width: 100%;\n    justify-content: center;\n  }\n\n  /* Wizard steps — mobile sizing */\n  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface {\n    padding: 0.85rem 0.65rem 1rem;\n  }\n\n  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__badge {\n    width: 2.65rem;\n    height: 2.65rem;\n    font-size: 1.05rem;\n  }\n\n  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__title {\n    font-size: 0.78rem;\n    max-width: 5.5rem;\n  }\n\n  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__connector-track {\n    height: 8px;\n  }\n\n  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface.is-lang-ar .twp-add-partner-steps__title {\n    font-size: 0.8rem;\n    max-width: 6.25rem;\n    line-height: 1.5;\n  }\n\n  .add-tripway-partner-form .twp-add-partner-steps--pro .twp-add-partner-steps__surface.is-lang-ar .twp-add-partner-steps__node {\n    min-width: 5.5rem;\n    max-width: 6.75rem;\n  }\n\n  .qrf-page--list .bs-brand-pagination-nav,\n  .qrf-page--list .qrf-list-pagination {\n    margin-top: 0.85rem;\n  }\n\n  .qrf-page--list .bs-brand-pagination .page-link,\n  .qrf-page--list .qrf-pagination .page-link {\n    padding: 0.35rem 0.55rem;\n    font-size: 0.8125rem;\n  }\n\n  /* Client offer view — stack actions on mobile */\n  .qrf-view-hero--actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .qrf-view-hero__actions {\n    margin-inline-start: 0;\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .qrf-view-copy-btn {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .qrf-view-copy-btn__arrow {\n    margin-inline-start: auto;\n  }\n\n  .qrf-customer-reg {\n    flex-wrap: wrap;\n  }\n\n  .qrf-customer-reg__content {\n    flex: 1 1 calc(100% - 3.5rem);\n  }\n\n  .qrf-switch--readonly {\n    margin-inline-start: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
